import CampaignDatasource from "./campaignInfo/CampaignDatasource";
import PriceFormatHelper from "./helpers/priceFormatter";
import BaseUrl from "./types/BaseUrl";
import ISelectedExtras from "./types/ISelectedExtras";
import Options from "./types/Options";

export default class CampaignDiscount {
  private datasource: CampaignDatasource;
  private priceFormatter: PriceFormatHelper;

  // acceptable options is { validDetector: ['param', 'cookie', 'localStorage'], merchandisingMergeMode: none (default) | non-valid-campaign | no-offer-campaign-items | all }
  constructor(baseUrl: string, options?: Record<string, any>) {
    const baseUrlInstance = new BaseUrl(baseUrl);
    this.datasource = new CampaignDatasource(baseUrlInstance, new Options(options));
    this.priceFormatter = new PriceFormatHelper(JSON.stringify(baseUrlInstance.getVendor().prices));
  }

  async getAllCategoriesDiscount() {
    return await this.datasource.getAllCategoriesCampaignInfo();
  }

  async getCategoryDiscount(category: string) {
    return await this.datasource.getCategoryCampaignInfo(category);
  }

  async getCategoryArticlesDiscount(category: string) {
    return await this.datasource.getCategoryArticlesCampaignInfo(category);
  }

  async getArticleDiscount(category: string, papId: string, selectedExtras?: ISelectedExtras) {
    if (!selectedExtras || (typeof selectedExtras === "object" && !Object.keys(selectedExtras).length)) {
      return await this.datasource.getArticleCampaignInfo(category, papId);
    }

    return await this.datasource.getArticleWithExtrasCampaignInfo(category, papId, selectedExtras);
  }

  getCampaignUUID(): string {
    return this.datasource.getCampaignUUID();
  }

  formatPrice(price: number, discountedFraction: number = 0): string {
    return this.priceFormatter.formatPrice(price, discountedFraction);
  }
}
